<template>
    <div>
        <div class="container-fluid detail-viewer"
            :style="{
                position: 'absolute', 
                top: 0, 
                left:0,
                height: '100vh',
                width: '100vw',
                pointerEvents: 'none'
            }">
            <div v-if="isVisible">
            <div
                
                v-for="(item, index) in items"
                :key="item.label"
                >
                    <div class="row"
                    :style="{ 
                        pointerEvents: 'all',
                        position: 'absolute',
                        left: item.location[0]*scale[0] + 'px',
                        top: item.location[1]*scale[1] + 'px',
                        width: '250px',
                        height: '100px'
                        }"
                    >   
                            <div class="col-4 justify-content-center float-right p-0">
                                <img
                                    v-if="!visibleLabels[index]"
                                    :src="labels[index]"
                                    @mouseenter=selLabel(index) 
                                    
                                    :style="{ 
                                        cursor: 'url(' + clickCursor + '), pointer',
                                        width: 60*scale[0] + 'px',
                                        height: 60*scale[1] + 'px'
                                    }"
                                >
                                <img v-if="visibleLabels[index]"
                                    :src="selectedLabels[index]"
                                    @mouseleave=deselLabel(index)
                                    @click="showMultiple(index)"
                                    :style="{ 
                                        cursor: 'url(' + clickCursor + '), pointer',
                                        width: 60*scale[0] + 'px',
                                        height: 60*scale[1] + 'px'
                                    }"
                                >
                            </div>
                            <div class="col-8 justify-content-left p-0" v-if="visibleLabels[index]">
                                <h3 class="item-title text-left" style="font-size: 2vh;">{{item.title}}</h3>
                                <h6 class="text-left mt-2" style="text-transform: uppercase; font-size: 1.5vh;">{{item.materials}}</h6>
                                <h6 class="text-left mt-0 pt-0" style="text-transform: uppercase;font-size: 1.5vh;">{{item.dimensions}}</h6>
                            </div>
                    </div>
                </div>
            </div> 
            <transition name="fade">
                <div  
                    v-if="lightboxVisible"
                    class="container-fluid overlay"
                    
                    :style="{ 
                        position: 'absolute',  
                        height: imgRescaledSize[1] + 'px', 
                        width: imgRescaledSize[0] + 'px',
                        top: 0,
                        left: 0,
                        zIndex: 1,
                        }"
                ></div>
            </transition>
            <div 
                v-if="lightboxVisible"
                @click="toggleLightbox()"
            >
            <!-- IF IMAGE IS LANDSCAPE -->
                <div v-if="this.checkImageProportions(this.curLightboxImgs[lightboxIndex])">
                    <div
                        :style="{
                            position: 'fixed', 
                            top: 0, 
                            left:0,
                            height: '100vh', 
                            width: '100vw',
                            zIndex: 50,
                            pointerEvents: 'all',
                        }"
                        >   
                        
                        <div class="row lightbox m-0 p-2"
                            :style="{ 
                                height: '100vh', 
                                width: '100vw',
                                margin: 0
                            }"
                        >
                            <div class="col d-flex justify-content-start align-self-center float-left p-0"
                            >
                                <img
                                    class="p-3"
                                    v-if="this.curLightboxImgs.length > 1"
                                    :src="leftCaret"
                                    @click.stop="decrementLightboxIndex()"
                                    :style="{ 
                                        cursor: 'url(' + clickCursor + '), auto',
                                        marginTop: 'auto',
                                        marginBottom: 'auto',
                                    }"
                                >
                            </div>
                            <!-- <div 
                                class="col-3 justify-content-start align-self-center"
                                >
                                <h5 class="text-left">{{this.items[selLabelIndex]["description"][0]}}</h5>
                            </div> -->
                            <div class="col-7 justify-content-center align-self-center"
                                :style="{
                                    alignItems: 'center',
                                    }"
                                >
                                <div class="row d-flex align-items-center justify-content-center"
                                    :style="{ 
                                            maxWidth: '100%',
                                            maxHeight: '60vh',
                                        }">
                                    <img
                                        class="float-left align-self-center"
                                        :src="curLightboxImgs[lightboxIndex].src"
                                        :style="{ 
                                            maxWidth: '100%',
                                            maxHeight: '60vh',
                                            marginTop: 'auto',
                                            marginBottom: 5,
                                            alignItems: 'center'
                                        }"
                                    >
                                </div>
                                <div class="row">
                                    <div class=col-6>
                                        <h5 class="text-left mt-4" style="font-size: 2vh;">{{this.items[selLabelIndex]["title"]}}</h5>
                                        <h6 class="text-left mt-3" style="text-transform: uppercase; font-size: 1.5vh;">{{this.items[selLabelIndex]["materials"]}}</h6>
                                        <h6 class="text-left mt-1" style="text-transform: uppercase;font-size: 1.5vh;">{{this.items[selLabelIndex]["dimensions"]}}</h6>
                                        <h6 class="text-left mt-4" style="font-size: 1.8vh;">{{this.items[selLabelIndex]["description"][lightboxIndex]}}</h6> 
                                        <h6 v-if="this.items[selLabelIndex]['credits']" class="text-left mt-4" style="font-size: 1.2vh;">{{this.items[selLabelIndex]["credits"][lightboxIndex]}}</h6> 
                                    </div>
                                </div>
                            </div>
                            <div class="col d-flex justify-content-sm-end align-self-center float-right"
                            >
                                <img
                                    class="p-3"
                                    v-if="this.curLightboxImgs.length > 1"
                                    :src="rightCaret"
                                    @click.stop="incrementLightboxIndex()"
                                    :style="{ 
                                        right: 0,
                                        left: 0,
                                        cursor: 'url(' + clickCursor + '), auto',
                                        marginTop: 'auto',
                                        marginBottom: 'auto',
                                    }"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div
                        :style="{
                            position: 'fixed', 
                            top: '10vh', 
                            left:0,
                            height: '80vh', 
                            width: '100vw',
                            zIndex: 50,
                            pointerEvents: 'all',
                        }"
                        >  
                    <!-- IF IMAGE IS PORTRAIT -->
                        <div class="row lightbox m-0 p-2"
                            :style="{ 
                                top: 0,
                                height: '100%', 
                                width: '100vw',
                                margin: 0,
                                zIndex: 50
                            }"
                        >
                        <div class="col-2 d-flex justify-content-start align-self-center float-left ml-auto p-0"
                        >
                            <img
                                class="p-3"
                                v-if="this.curLightboxImgs.length > 1"
                                :src="leftCaret"
                                @click.stop="decrementLightboxIndex()"
                                :style="{ 
                                    cursor: 'url(' + clickCursor + '), auto',
                                    marginTop: 'auto',
                                    marginBottom: 'auto',
                                    zIndex: 50
                                }"
                            >
                        </div>
                        <!-- <div 
                            class="col-3 justify-content-start align-self-center"
                            >
                            <h5 class="text-left">{{this.items[selLabelIndex]["description"][0]}}</h5>
                        </div> -->
                        <div class="col-8 d-flex"
                            :style="{
                                maxHeight: '100%',
                                }"
                            >
                            <div class="col align-items-end justify-contents-center float-right"
                                :style="{ 
                                    maxHeight: '100%',
                                    height: '100%'
                                }">
                                <img
                                    class="img-fluid float-right"
                                    v-lazy="curLightboxImgs[lightboxIndex].src"
                                    :style="{ 
                                        maxHeight: '100%',
                                        width: 'auto',
                                        padding: 5,
                                    }"
                                >
                            </div>
                            <div class="col-3 align-items-start"
                                :style="{
                                    maxHeight: '100%',
                                }"
                            >
                                <h5 class="text-left mt-4" style="font-size: 2vh;">{{this.items[selLabelIndex]["title"]}}</h5>
                                <h6 class="text-left mt-3" style="text-transform: uppercase; font-size: 1.5vh;">{{this.items[selLabelIndex]["materials"]}}</h6>
                                <h6 class="text-left mt-1" style="text-transform: uppercase;font-size: 1.5vh;">{{this.items[selLabelIndex]["dimensions"]}}</h6>
                                <h6 class="text-left mt-4" style="font-size: 1.8vh;">{{this.items[selLabelIndex]["description"][lightboxIndex]}}</h6> 
                                <h6 v-if="this.items[selLabelIndex]['credits']" class="text-left mt-4" style="font-size: 1.2vh;">{{this.items[selLabelIndex]["credits"][lightboxIndex]}}</h6> 
                            </div>
                        </div>
                        <div class="col-2 d-flex justify-content-end align-self-center float-right ml-auto"
                        >
                            <img
                                class="p-3"
                                v-if="this.curLightboxImgs.length > 1"
                                :src="rightCaret"
                                @click.stop="incrementLightboxIndex()"
                                :style="{ 
                                    cursor: 'url(' + clickCursor + '), auto',
                                    marginTop: 'auto',
                                    marginBottom: 'auto',
                                    zIndex: 50
                                }"
                            >
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '../main';
export default {
  name: "DetailViewer",
  props: ["items", "imgSize", "isVisible"],
  watch: { 
      	isVisible: function(newVal, oldVal) { // watch it
          if (oldVal != newVal && this.lightboxVisible) {
              this.lightboxVisible = false;
          }
        }
    },
  components: {
  },
  data: function() {
      return {
          currentLabels: [],
          visibleLabels: [],
          scale: [1, 1],
          clickCursor: require('@/assets/cursors/pointer.svg'),
          lightboxVisible: false,
          lightboxIndex: 0,
          lightboxImages: [],
          selLabelIndex: 0,
          imgRescaledSize: [],
          curLightboxImgs: [],
          leftCaret: require('@/assets/icons/leftCaret.png'),
          rightCaret: require('@/assets/icons/rightCaret.png'),
      };
  },
  computed: {
      labels: function() {
          let svgs = [];
          for (let i = 1; i < this.items.length+1; i++) {
              svgs.push(require("@/assets/labels/" + i + ".png"));
          }
          return svgs;
      },
      selectedLabels: function() {
          let svgs = [];
          for (let i = 1; i < this.items.length+1; i++) {
              svgs.push(require("@/assets/labels/" + i + "sel.png"));
          }
          return svgs;
      }
  },
  methods: {
      selLabel(index) {
          if (!this.visibleLabels[index]) {
              this.visibleLabels.splice(index, 1, true);
              this.selLabelIndex = index;
          }
      },
      deselLabel(index) {
          this.visibleLabels.splice(index, 1, false);
      },
      setScaling() {
            let imgSizeRatio = (this.imgSize[0]/this.imgSize[1]);
            let screenRatio = window.innerWidth/window.innerHeight;
            let modHeight = this.imgSize[1] * (window.innerWidth/this.imgSize[0]);
            let modWidth = this.imgSize[0] * (window.innerHeight/this.imgSize[1]);
            let height = ((screenRatio > imgSizeRatio) ? modHeight : window.innerHeight);
            let width = ((screenRatio > imgSizeRatio) ? window.innerWidth : modWidth);
            this.scale = [width/this.imgSize[0], height/this.imgSize[1]];
            this.imgRescaledSize = [width, height];
      },
    showSingle(index) {
        console.log(index);
        if (this.lightboxImages) {
            this.toggleLightbox();
        }
    },
    onMaskClicked(index) {
        this.showMultiple(index);
        this.selLabelIndex = index;
    },
    
    showMultiple(labelIndex) {
        this.curLightboxImgs = this.lightboxImages[labelIndex];
        this.lightboxIndex = 0  // index of imgList
        if (this.curLightboxImgs && this.curLightboxImgs.length>0) {
            this.toggleLightbox();
        } 
    },
    decrementLightboxIndex() {
        if (this.lightboxIndex > 0) {
            this.lightboxIndex--;
        }
        else {
            this.lightboxIndex = this.curLightboxImgs.length-1;
        }
    },
    incrementLightboxIndex() {
        if (this.lightboxIndex < this.curLightboxImgs.length-1) {
            this.lightboxIndex++;
        }
        else {
            this.lightboxIndex = 0;
        }
    },
    toggleLightbox() {
        this.lightboxVisible = !this.lightboxVisible;
    },
    checkImageProportions(img) {
        if (img.width > img.height) {
            return true;
        }
        return false;
    },
    loadLightboxImages() {
          let lightboxImgs = [];
          for (let j = 0; j< this.items.length; j++) {
              lightboxImgs.push([]);
                for (let i = 0; i < this.items[j]["detailImage"].length; i++) {
                    if (this.items[j]["detailImage"][i]) {
                        let path = require("@/assets/galleries/details" + this.$route.path + '/' + this.items[j]["detailImage"][i]);
                        let imageTemp = new Image();
                        imageTemp.src = path;
                        lightboxImgs[j].push(imageTemp);
                    }
                }
          }
        this.lightboxImages = lightboxImgs;
    }
  },
  created() {
    this.currentLabels = this.labels;
    for (let i = 1; i < this.items.length+1; i++) {
        this.visibleLabels.push(false);
    }
    this.setScaling();

    window.addEventListener("resize", this.setScaling);

    bus.$on('showLightbox', (data) => {
        this.onMaskClicked(data);
    });
  },
  mounted() {
      setTimeout(() => {
          this.loadLightboxImages();
      },1000);
    
  },
  destroyed() {
      window.removeEventListener("resize", this.setScaling);
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
    margin: 40px 0 0;
    /* font-family: 'Riposte Lazer'; */
    font-family: 'Inter Tight', sans-serif;
    font-weight: 100;
}

.item-title {
    /* font-family: 'Figue'; */
    font-family: 'Playfair Display', serif;
    font-size: 1.2rem;
    color:white;
    text-align: left;
}

.container-fluid {
    cursor: 'url("../assets/cursors/pointer.svg"), auto';
}
</style>

<style scoped>

.lightbox {
    z-index:20;
}

.overlay {
  background-color: black;
  opacity: 0.8;
  z-index: 1;
  pointer-events: none;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0s;
}
.fade-enter-to {
  opacity: 0.8;
}
.fade-leave {
  opacity: 0.8;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-leave-to {
  opacity: 0;
}

.detail-viewer {
    z-index: 12;
}
</style>

